import styles from '../../styles/admin/List.module.scss'
import { ClassStatusListProps } from '../../types/list'

const ClassStatusListItem = ({
  level,
  classCounts,
  questionCounts,
}: ClassStatusListProps) => {
  return (
    <div className={styles.listItem}>
      <div className={styles.cell} style={{ width: '50px' }}>
        {level}
      </div>
      <div className={styles.cell} style={{ width: '50px' }}>
        {classCounts}
      </div>
      <div className={styles.cell} style={{ width: '50px' }}>
        {questionCounts}
      </div>
    </div>
  )
}

export default ClassStatusListItem
